import classNames from 'classnames';
import { Icon, useTranslation } from '@testsigma/atoms';

import { useGlobalState } from '@providers/global-context-provider';

import { useMetadataRefresh } from '../../hooks';

interface ButtonIconProps {
  isRefreshing: boolean;
}

interface ButtonLabelProps {
  isRefreshing: boolean;
  isPrimaryMenuExpanded: boolean;
}

interface RefreshMetadataMenuProps {
  isPrimaryMenuExpanded: boolean;
  connectionId: number;
}

const ButtonIcon = (props: ButtonIconProps) => {
  const { isRefreshing } = props;
  const icon = isRefreshing ? 'loader' : 'refresh';

  return (
    <Icon
      className={classNames(
        icon ? 'text-[20px] !text-unique-800' : 'text-[20px]',
        isRefreshing ? 'animate-spin' : '',
      )}
      name={icon}
    />
  );
};

const ButtonLabel = (props: ButtonLabelProps) => {
  const { isRefreshing, isPrimaryMenuExpanded } = props;
  const { t } = useTranslation();

  const buttonText = isRefreshing
    ? t('left.nav.updating_metadata')
    : t('left.nav.refresh_metadata');

  if (isPrimaryMenuExpanded === false) {
    return null;
  }

  return (
    <span
      className={classNames(
        'ml-1 leading-5',
        'font-medium text-sm text-secondary-1000',
      )}
    >
      {buttonText}
    </span>
  );
};

const RefreshMetadataMenu = (props: RefreshMetadataMenuProps) => {
  const { connectionId, isPrimaryMenuExpanded } = props;

  if (!connectionId) {
    return null;
  }

  const { handleMetadataRefresh } = useMetadataRefresh(connectionId);
  const { refreshingMetadataConnectionId } = useGlobalState();

  // Update the isRefreshing check to use Set.has()
  const isRefreshing = refreshingMetadataConnectionId.has(connectionId);

  return (
    <div
      className={classNames(
        'flex w-full justify-center items-center',
        'border-[0.5px] rounded-md',
        'px-4 py-1.5',
        'shadow',
        'overflow-hidden',
        'text-unique-800',
        isRefreshing
          ? 'bg-warning-200 border-warning-600 cursor-not-allowed'
          : 'bg-secondary-unique-1000 border-secondary-100 cursor-pointer',
      )}
      onClick={() => {
        if (!isRefreshing) {
          handleMetadataRefresh('ACTION');
        }
      }}
    >
      <ButtonIcon isRefreshing={isRefreshing} />
      <ButtonLabel
        isRefreshing={isRefreshing}
        isPrimaryMenuExpanded={isPrimaryMenuExpanded}
      />
    </div>
  );
};

export { RefreshMetadataMenu };
